import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Collapsible from '@radix-ui/react-collapsible';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { capitalize } from 'lodash';

const TransactionUtm = () => {
    const { data: transaction } = useCurrentTransactionOrById();

    return (
        <Collapsible.Root defaultOpen={true}>
            <Collapsible.Trigger
                className={
                    'group flex w-full items-center justify-between gap-2 rounded-md bg-gray-100 px-3 py-2'
                }
            >
                <p className={'text-sm font-medium'}>Sources & UTMs</p>
                <FontAwesomeIcon
                    className={'group-radix-state-open:rotate-180'}
                    icon={faChevronDown}
                />
            </Collapsible.Trigger>
            <Collapsible.Content className={'flex flex-col gap-6 px-3 py-4'}>
                {transaction?.sources.map((source, index) => (
                    <div key={`${source.key}-${index}`} className={'flex flex-col'}>
                        <p className={'text-sm font-medium text-gray-800'}>
                            {capitalize(source.key)}
                        </p>
                        <p className={'text-gray-600'}>{source.value}</p>
                    </div>
                ))}
            </Collapsible.Content>
        </Collapsible.Root>
    );
};

export { TransactionUtm };
